<!-- 联系我们 -->
<template>
  <div class="template-container">
    <div class="box-title">{{ $t("contactNew.text1") }}</div>
    <div class="box-main">
      <div class="box-main-left">
        <div class="left-title">{{ $t("contactNew.text2") }}</div>
        <div class="left-one-box">
          <div class="left-text1">
            <img class="img-logo" src="/static/images/about/contact/im1.png"/>
            {{ $t("contactNew.text3") }}
          </div>
          <div class="left-text1">
            <img
              style="height: 22px"
              class="img-logo"
              src="/static/images/about/contact/im3.png"
            />
            {{ $t("contactNew.text4") }}
          </div>
          <div class="left-text1">
            <img class="img-logo" src="/static/images/about/contact/im2.png"/>
            {{ $t("contactNew.text5") }}
          </div>
          <div class="left-text1">
            <img
              style="height: 18px"
              class="img-logo"
              src="/static/images/about/contact/im4.png"
            />
            {{ $t("contactNew.text6") }}
          </div>
          <div class="line-v"></div>
        </div>
        <div class="left-title">{{ $t("contactNew.text7") }}</div>
        <div class="left-two-box">
          <div class="left-name" style="margin-top: 23px">
            <div class="line-t"></div>
            {{ $t("contactNew.text8") }}
          </div>
          <div>
            <!--            中文区-->
            <div v-if="$i18n.locale == 'zh_CN'">
              <div class="left-text2" >
                <img
                  class="img-phone"
                  src="/static/images/about/contact/imt.png"
                />
                {{ $t("contactNew.text8_1") }}
              </div>
            </div>
            <!--            英文区-->
            <div v-if="$i18n.locale != 'zh_CN'">
<!--              <div class="left-text2" >-->
<!--                <img-->
<!--                  class="img-phone"-->
<!--                  src="/static/images/about/contact/imp.png"-->
<!--                />-->
<!--                {{ $t("contactNew.text10") }}-->
<!--              </div>-->
              <div >
                <div class="left-text2" style="color: #0f1013;font-size: 14px;font-weight: 600">Sales</div>
                <div class="left-text2">Susie:+8613466409331(TEL)</div>
                <div class="left-text2"  style="display: flex"><div> <span>ابراهيم حسن</span></div> :+8613501233621((TEL), hassan@hovwing.com(Email)</div>
                <div class="left-text2" style="color: #0f1013;font-size: 14px;font-weight: 600">Technical support</div>
                <div class="left-text2">Liu:+8613220114637（TEL）</div>


              </div>
            </div>
          </div>
          <div class="left-name">
            <div class="line-t"></div>
            {{ $t("contactNew.text14") }}
          </div>
          <div class="left-text2"> {{ $t("contactNew.text18_1") }}</div>
          <div class="left-name" v-if="$i18n.locale == 'zh_CN'">
            <div class="line-t"></div>
            {{ $t("contactNew.text15") }}
          </div>
          <div class="left-text2" v-if="$i18n.locale == 'zh_CN'">
            {{ $t("contactNew.text16") }}
          </div>
        </div>
      </div>
      <div class="line-h"></div>
      <div class="box-main-right">
        <div class="right-item1">
          <div class="item-box">
            <span>{{ $t("contactNew.text17") }}<span style="color: red;">*</span></span>
            <input class="item-input" v-model.trim="name"/>
          </div>
          <div class="item-box">
            <span>{{ $t("contactNew.text18") }}<span style="color: red;">*</span></span>
            <input class="item-input" v-model.trim="email"/>
          </div>
        </div>
        <div class="right-item1">
          <div class="item-box">
            <span>{{ $t("contactNew.text19") }}<span style="color: red;">*</span></span>
            <input class="item-input" v-model.trim="phone"/>
          </div>
          <div class="item-box">
            <span>{{ $t("contactNew.text20") }}<span style="color: red;">*</span></span>
            <input class="item-input" v-model.trim="company"/>
          </div>
        </div>
        <div class="right-item1">
          <div class="item-box">
            <span>{{ $t("contactNew.text21") }}<span style="color: red;">*</span></span>
            <input class="item-input" v-model.trim="address"/>
          </div>
        </div>
        <div class="right-item1">
          <div class="item-box">
            <span> {{ $t("contactNew.text22") }}<span style="color: red;">*</span></span>
            <textarea class="item-input2" v-model.trim="message"></textarea>
          </div>
        </div>
        <div class="line-v" style="margin-bottom: 10px"></div>
        <div class="tips">
          <span>{{ $t("contactNew.text23") }}</span>
          <span class="span"
          ><router-link to="/privacyPolicy">{{
              $t("contactNew.text24")
            }}</router-link></span
          >
          <span>{{ $t("contactNew.text25") }}</span>
          <span class="span"
          ><router-link to="/termsConditions">{{
              $t("contactNew.text26")
            }}</router-link></span
          >
        </div>
        <div class="sub-box">
          <div v-show="isLoad" style="font-size: 20px; margin-right: 5px;"><i class="el-icon-loading"></i></div>
          <div class="right-submit" @click="sendEmail()" :style="isLoad?'opacity:0.5':'opacity:1'">
            {{ $t("contactNew.text27") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//  import serve from '../../common/scripts/serve.js'
//var nodemailer = require('nodemailer');
export default {
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      company: '',
      address: '',
      message: '',
      isLoad: false,
    };
  },
  methods: {
    sendEmail() {
      if (this.isLoad) {
        return;
      }
      //const sendEmialRes =  sendEmail('1101@qq.com', '1102@qq.com', '1101@qq.com', 'sqmaswdwd', '我是发送的信息').catch(console.error)
      if (!this.name) {
        this.$message({
          message: this.$t("contactNew.text29"),
          type: 'warning'
        });
        return;
      }
      if (!this.email) {
        this.$message({
          message: this.$t("contactNew.text30"),
          type: 'warning'
        });
        return;
      }
      if (!this.phone) {
        this.$message({
          message: this.$t("contactNew.text31"),
          type: 'warning'
        });
        return;
      }
      if (!this.company) {
        this.$message({
          message: this.$t("contactNew.text32"),
          type: 'warning'
        });
        return;
      }
      if (!this.address) {
        this.$message({
          message: this.$t("contactNew.text33"),
          type: 'warning'
        });
        return;
      }
      if (!this.message) {
        this.$message({
          message: this.$t("contactNew.text34"),
          type: 'warning'
        });
        return;
      }
      this.isLoad = true;
      let that = this;
      const form = `name=${this.name}&email=${this.email}&phone=${this.phone}&company=${this.company}&address=${this.address}&message=${this.message}`;

      var ajaxObj = new XMLHttpRequest();
      ajaxObj.open("POST", 'http://localhost:3000/send', true);
      ajaxObj.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      ajaxObj.send(form);
      ajaxObj.onreadystatechange = function () {
        that.isLoad = false;
        if (ajaxObj.readyState == 4 && ajaxObj.status == 200) {
          that.$notify({
            title: that.$t("contactNew.text28"),
            message: that.$t("contactNew.text28_1"),
            type: 'success'
          });
          console.log(ajaxObj.responseText);
          that.name = '';
          that.email = '';
          that.phone = '';
          that.company = '';
          that.address = '';
          that.message = '';
        }
      };
    },
  },
};
</script>

<style lang='stylus' scoped>
.template-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  background: #EBEBEB;

  .span:hover {
    color: #069DF9;
  }

  .span {
    cursor: pointer;
    text-decoration: underline;
  }

  .tips {
    font-size: 11px;
    font-weight: 500;
    color: #888888;
  }

  .box-title {
    margin: 46px;
    font-size: 32px;
    font-weight: 500;
    line-height: 32px;
    text-align: center;
    letter-spacing: 0px;
    color: #111111;
    font-weight: 700;
  }

  .box-main {
    width: 1420px;
    background-color: white;
    display: flex;
    padding-bottom: 78px;
    margin-bottom: 40px;

    .line-v {
      height: 1px;
      background: #ebebeb;
      margin: 24px 0px 18px 0px;
    }

    .line-h {
      background: #ebebeb;
      width: 1px;
      margin: 21px 46px 21px 90px;
    }

    .line-t {
      background-color: #161616;
      width: 2px;
      height: 17px;
      margin-right: 6px;
    }

    .box-main-left {
      padding: 27px 0px 10px 18px;
      width: 551px;

      .left-title {
        font-size: 16px;
        font-weight: 700;
        color: #111111;
        font-family: '黑体';
      }

      .left-one-box {
        margin: 40px 0px 29px 69px;
      }

      .left-two-box {
        margin-left: 55px;
      }

      .img-logo {
        object-fit: contain;
        width: 24px;
        height: 24px;
        opacity: 1;
        margin-right: 15px;
      }

      .left-text1 {
        display: flex;
        align-items: center;
        height: 40px;
        font-size: 12px;
        font-weight: 600;
        color: #999999;
      }

      .left-text2 {
        margin-left: 9px;
        display: flex;
        align-items: center;
        font-family: '黑体';
        font-size: 13px;
        font-weight: 500;
        line-height: 30px;
        color: #666666;

        .img-phone {
          margin-right: 7px;
          width: 14px;
          height: 14px;
        }
      }

      .left-name {
        display: flex;
        font-weight: 700;
        font-size: 18px;
        margin-top: 37px;
      }
    }

    .box-main-right {
      flex: 1;
      padding: 78px 0px 0px 0px;

      .right-item1 {
        display: flex;

        .item-box {
          padding-right: 46px;
          padding-bottom: 15px;
          display: flex;
          flex-direction: column;
          flex: 1;
          font-size: 13px;
          font-weight: 500;
          color: #3D3D3D;

          .item-input {
            width: 100%;
            margin-top: 5px;
            height: 30.5px;
            background: #F7F7F7;
            border: 1px solid #EBEBEB;
          }

          .item-input2 {
            margin-top: 5px;
            height: 130.5px;
            background: #F7F7F7;
            border: 1px solid #EBEBEB;
          }
        }
      }

      .sub-box {
        align-items: center;
        margin-top: 82px;
        display: flex;
        justify-content: flex-end;
      }

      .right-submit {
        text-align: center;
        width: 233px;
        height: 42px;
        opacity: 1;
        background: #161616;
        font-weight: 600;
        line-height: 42px;
        color: #FFFFFF;
        font-family: '黑体';

        margin-right: 46px;
      }
    }
  }
}

// 移动端
@media all and (min-width: 320px) and (max-width: 768px) {
  .template-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    box-sizing: border-box;
    background: #EBEBEB;

    .tips {
      font-size: 11px;
      font-weight: 500;
      color: #888888;
    }

    .box-title {
      margin: 46px;
      font-size: 32px;
      font-weight: 500;
      line-height: 32px;
      text-align: center;
      letter-spacing: 0px;
      color: #111111;
      font-weight: 700;
    }

    .box-main {
      width: 100%;
      background-color: white;
      display: flex;
      flex-direction: column;
      padding-bottom: 78px;
      margin-bottom: 40px;

      .line-v {
        display: none;
        height: 1px;
        background: #ebebeb;
        margin: 24px 0px 18px 0px;
      }

      .line-h {
        display: none;
        background: #ebebeb;
        width: 1px;
        margin: 21px 46px 21px 90px;
      }

      .line-t {
        background-color: #161616;
        width: 2px;
        height: 17px;
        margin-right: 6px;
      }

      .box-main-left {
        padding: 27px 0px 10px 18px;
        width: 100%;

        .left-title {
          font-size: 16px;
          font-weight: 700;
          color: #111111;
          font-family: '黑体';
        }

        .left-one-box {
          margin: 40px 0px 29px 20px;
        }

        .left-two-box {
          margin-left: 20px;
        }

        .img-logo {
          object-fit: contain;
          width: 24px;
          height: 24px;
          opacity: 1;
          margin-right: 15px;
        }

        .left-text1 {
          display: flex;
          align-items: center;
          height: 40px;
          font-size: 12px;
          font-weight: 600;
          color: #999999;
        }

        .left-text2 {
          margin-left: 9px;
          display: flex;
          align-items: center;
          height: 30px;
          font-family: '黑体';
          font-size: 13px;
          font-weight: 500;
          line-height: 30px;
          color: #666666;

          .img-phone {
            margin-right: 7px;
            width: 14px;
            height: 14px;
          }
        }

        .left-name {
          display: flex;
          font-weight: 700;
          font-size: 18px;
          margin-top: 37px;
        }
      }

      .box-main-right {
        flex: 1;
        padding: 78px 0px 20px 20px;

        .right-item1 {
          display: flex;

          .item-box {
            padding-right: 20px;
            padding-bottom: 15px;
            display: flex;
            flex-direction: column;
            flex: 1;
            font-size: 13px;
            font-weight: 500;
            color: #3D3D3D;

            .item-input {
              margin-top: 5px;
              height: 30.5px;
              background: #F7F7F7;
              border: 1px solid #EBEBEB;
            }

            .item-input2 {
              margin-top: 5px;
              height: 130.5px;
              background: #F7F7F7;
              border: 1px solid #EBEBEB;
            }
          }
        }

        .sub-box {
          display: flex;
          justify-content: center;
        }

        .right-submit {
          text-align: center;
          width: 233px;
          height: 42px;
          opacity: 1;
          background: #161616;
          font-weight: 600;
          line-height: 42px;
          color: #FFFFFF;
          font-family: '黑体';
          margin-top: 82px;
          margin-right: 0px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about/contactNew.vue